import { boxShadows, corners, marginBottom, marginLeft, marginTop, paddingX, paddingY, typography } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Notification from "../Notification/Notification";
import styled from "styled-components";
export const Label = styled.label`
  display: inline-block;
  ${typography.body};
  color: ${({
  theme
}) => theme.brand.cssVars["--d-muted"]};
  &::first-letter {
    text-transform: capitalize;
  }
`;
export const HelpText = styled.div`
  ${typography.small}
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]}
`;
export const RequiredStar = styled(FontAwesomeIcon).attrs({
  icon: faAsterisk
})`
  max-height: 0.5rem;
  max-width: 0.5rem;
  color: ${({
  theme
}) => theme.brand.cssVars["--d-error"]};
  ${marginLeft.xs}
  ${marginBottom.s}
`;
export const Input = styled.input<{
  error: boolean;
}>`
  width: 100%;
  background-color: ${({
  theme
}) => theme.brand.cssVars["--d-card"]};
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
  ${paddingX.s}
  ${paddingY.xs}

  ${corners.s}
  border: 1px solid ${({
  error,
  theme
}) => error ? theme.brand.cssVars["--d-error"] : theme.brand.cssVars["--d-border"]};

  ${typography.body}

  &::placeholder {
    color: ${({
  theme
}) => theme.brand.cssVars["--d-muted"]};
  }

  &:focus {
    /*
     * Was outline: none; border-color: --d-primary; — a thin 1px border
     * whose colour comes from the brand's own primary colour, which can
     * have poor contrast against the page background for some brand
     * colours (see boxShadows.focusRing for the WCAG 2.4.7 fix rationale).
     */
    border: 1px solid
      ${({
  error,
  theme
}) => error ? theme.brand.cssVars["--d-error"] : theme.brand.cssVars["--d-primary"]};
    ${boxShadows.focusRing}
  }
`;
export const Error = styled(Notification).attrs({
  variant: "warning"
})``;

// Plugs the gaps in the background colour caused by rounded corners on Input and Error.
// Input and Error should be put in this container
export const ErrorConnector = styled.div<{
  show?: boolean;
}>`
  background-color: ${({
  show,
  theme
}) => show ? applyOpacity(theme.brand.cssVars["--d-error"], 0.1, false) : "none"};
  ${corners.m}
  ${marginTop.s}
  ${marginBottom.m}
`;